import LoginForm from "@containers/Account/LoginForm";
import Heading from "@components/Heading";
import Button from "@components/Button";

const RCALogin = () => (
  <div className="space-y-[20px]">
    <Heading as="h4" display="h2" title="Intra in cont" />

    <div className="text-sm text-gray-700 mb-6">
      Pentru a continua, este necesar sa te autentifici in contul de client.
      Daca nu ai unul, iti poti crea unul rapid, mai jos.
    </div>

    <Button href="/cont/intra" title="Creeaza cont" />

    <div className="bg-white py-[20px] lg:py-[64px] px-[16px]">
      <div className="lg:max-w-[50%] mx-auto">
        <LoginForm />
      </div>
    </div>
  </div>
);

export default RCALogin;
